'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _intersection = require('lodash/fp/intersection');

var _intersection2 = _interopRequireDefault(_intersection);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _getSchemaKeys = require('../../../utils/schema/getSchemaKeys');

var _getSchemaKeys2 = _interopRequireDefault(_getSchemaKeys);

var _FieldSelect = require('./FieldSelect');

var _FieldSelect2 = _interopRequireDefault(_FieldSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createOptions(_ref) {
  var schema = _ref.schema,
      _ref$setting = _ref.setting,
      setting = _ref$setting === undefined ? {} : _ref$setting;

  var options = (0, _getSchemaKeys2.default)(schema, true).filter(function (opt) {
    return !['_id', '@@createdAt', '@@updatedAt'].includes(opt);
  });

  var _setting$ignore = setting.ignore,
      ignore = _setting$ignore === undefined ? [] : _setting$ignore,
      _setting$accept = setting.accept,
      accept = _setting$accept === undefined ? [] : _setting$accept;


  if (accept.length > 0) return (0, _intersection2.default)(options, accept);
  return options.filter(function (opt) {
    return !['_id'].concat(_toConsumableArray(ignore)).includes(opt);
  }).map(function (opt) {
    return Array.isArray(opt) ? opt.join('.') : opt;
  });
}

var FieldSelect = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  schema: _propTypes.object.isRequired,
  setting: (0, _propTypes.shape)({
    ignore: _propTypes.array,
    accept: _propTypes.array
  })
}), (0, _withPropsOnChange2.default)(['schema', 'setting'], function (props) {
  return {
    options: createOptions(props),
    formatter: function formatter(key) {
      return _ramda2.default.path(_ramda2.default.intersperse('contents', key.split('.')), props.schema.contents).name;
    }
  };
}), (0, _exposeProps2.default)(['options', 'formatter']))(_FieldSelect2.default);

FieldSelect.displayName = 'FieldSelect';

exports.default = FieldSelect;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/FieldSelect/index.js
// module id = 1301
// module chunks = 0